module.exports = __webpack_public_path__ + "img/SEAT-CUPRA.4cce5de5.png";